export interface SiteNavItem {
  key: string;
  label: string;
  to: string;
  hash?: string;
}

export const siteNavItems: SiteNavItem[] = [
  { key: 'home', label: 'Home', to: '/', hash: 'top' },
  { key: 'how-it-works', label: 'How It Works', to: '/how-it-works' },
  { key: 'gold-strategy', label: 'Gold Strategy', to: '/gold-strategy' },
  { key: 'trade-journal', label: 'Trade Journal', to: '/trade-journal' },
  { key: 'mt5-setup', label: 'MT5 Setup', to: '/mt5-setup' },
];

/**
 * Resolves a nav item to a link target. When we are already on the home page,
 * hash links scroll within the page; from any other page they navigate back to
 * the home page with a clean path (no hash), so the router actually changes
 * route and the page lands at the top.
 */
export function navHref(item: SiteNavItem, current: string): string {
  if (item.hash && current === 'home') {
    return `#${item.hash}`;
  }
  return item.to;
}